<template>
  <div class="common-layout">
    <div class="homeview-container">
      <div class="homeview-header">
        <div class="homeview-header-banner">
          <!-- <navbar classname="home"></navbar> -->
           <!-- <Header></Header> -->
        </div>
      </div>
      <newhongpage></newhongpage>
      <!-- <div class="homemain-style">
        <Maintop></Maintop><Maincenter></Maincenter>
        <Mainbottom></Mainbottom>
      </div> -->
      <!-- <div class="homefooter-style"><Footer name="home"></Footer></div> -->
    </div>
  </div>
</template>

<script setup>
import newhongpage from "@/views/newhome/newhomepage.vue";

import navbar from "@/components/navbar.vue";
import Footer from "@/components/footer.vue";
import Header from "@/views/homepage/header.vue";
import Maintop from "@/views/homepage/maintop.vue";
import Maincenter from "@/views/homepage/maincenter.vue";
import Mainbottom from "@/views/homepage/mainbottom.vue";
</script>

<style lang="scss" scoped>
// @import "@/assets/scss/theme.scss";

// .common-layout {
//   background-color: #000;
//   .homeview-container {
//     // margin: 0 auto;
//     width: 100%;
//     margin: 0 auto;
//     box-sizing: border-box;
//     @media screen and (max-width: 768px) {
//       // background-color: skyblue;
//     }
//     @media screen and (min-width: 769px) and (max-width: 1200px) {
//       // background-color: pink;
//     }
//     @media screen and (min-width: 1201px) and (max-width: 2600px) {
//       // background-color: yellow;
//       // 头部样式
//       .homeview-header {
//         width: 100%;
//         margin: 0 auto;
//         height: 620px;
//         box-sizing: border-box;
//         // background: #090711;
//         background: #090711;
//         // background-color: yellow;
//         // width: 88%;
//         // margin: 0 auto;
//         // background: #090711 url(@/assets/image/homePage/banner.png) no-repeat center;
//         // z-index: 1; /* 确保内容层位于背景层之上 */
//       }
//       // 中间内容样式
//       .homemain-style {
//         background: #090711;
//         // background: #fff;
//         width: 100%;
//         // height: 743px;
//         position: relative;

//         // top: -150px;
//       }
//       //尾部样式
//       .homefooter-style {
//         background: #000;
//         width: 100%;
//         height: auto;
//       }
//     }
//   }
// }
</style>
